import script from "./ClubHighlightList.vue?vue&type=script&setup=true&lang=js"
export * from "./ClubHighlightList.vue?vue&type=script&setup=true&lang=js"

import "./ClubHighlightList.vue?vue&type=style&index=0&id=c3c4285c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c3c4285c"]])

export default __exports__